<template>
		<img :src="imgSrc" :alt="imgAlt" :style="style" />
</template>

<script>
export default {
	name: 'PostSMTPImg',
	props: {
		src: {
			type: String,
			required: true
		},
		alt: {
			type: String,
			default: '',
		},
		style: {
			type: Object,
			default: () => ({})
		},
		showPoint: {
			type: Boolean,
			default: false
		}
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
	} ),

	methods: {
		explode( delimiter, string ) {
			return String( string ).split( delimiter );
		},

		strContains( needle, haystack ) {
			return String( haystack ).indexOf( needle ) !== -1;
		}
	},

	computed: {
		imgSrc() {
			if ( this.strContains( 'bell.svg', this.src ) ) {
				if ( this.showPoint ) {
					var src = this.explode( 'bell.svg', this.src );
					return src[ 0 ] + 'bell-point.svg';
				}
			}
			return this.src;
		},
		imgAlt() {
			if ( typeof this.alt === 'string' && this.alt.trim() ) {
				return this.alt.trim();
			}
			return 'Post SMTP ' + this.src;
		},
	}
}
</script>

<style scoped>

</style>